const preferencesRoot = '/preferences'

export default { 
	LOGIN: '/login',
	JOBS: '/jobs',
	PREFERENCES: preferencesRoot,
	LEADS_TOP_UP: `${preferencesRoot}/leads-top-up`
}
